
import { useBroker } from '@/hooks/use-broker';
import { useApplications } from '@/hooks/use-applications';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { UsersIcon, FileTextIcon, ClipboardListIcon } from 'lucide-react';
import { LinkedUsersList } from './LinkedUsersList';
import { LinkedUsersApplications } from './LinkedUsersApplications';
import { LinkedUsersQuotes } from './LinkedUsersQuotes';
import { BrokerReferralCodeField } from './BrokerReferralCodeField';

export const BrokerDashboard = () => {
  const { linkedUsers, isLoading: isLoadingBroker } = useBroker();
  const { applications, isLoading: isLoadingApplications } = useApplications();
  
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-3xl font-bold">Broker Dashboard</h2>
      </div>
      
      <BrokerReferralCodeField />
      
      <Tabs defaultValue="users">
        <TabsList className="mb-4">
          <TabsTrigger value="users" className="flex items-center">
            <UsersIcon className="h-4 w-4 mr-2" />
            Linked Clients
          </TabsTrigger>
          <TabsTrigger value="applications" className="flex items-center">
            <FileTextIcon className="h-4 w-4 mr-2" />
            Client Applications
          </TabsTrigger>
          <TabsTrigger value="quotes" className="flex items-center">
            <ClipboardListIcon className="h-4 w-4 mr-2" />
            Client Quotes
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="users">
          <LinkedUsersList linkedUsers={linkedUsers} isLoading={isLoadingBroker} />
        </TabsContent>
        
        <TabsContent value="applications">
          <LinkedUsersApplications 
            linkedUsers={linkedUsers} 
            applications={applications} 
            isLoading={isLoadingBroker || isLoadingApplications} 
          />
        </TabsContent>
        
        <TabsContent value="quotes">
          <LinkedUsersQuotes 
            linkedUsers={linkedUsers} 
            isLoading={isLoadingBroker} 
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};
